import { render, staticRenderFns } from "./DepartmentListItem.vue?vue&type=template&id=58c13b6d&scoped=true"
import script from "./DepartmentListItem.vue?vue&type=script&lang=js"
export * from "./DepartmentListItem.vue?vue&type=script&lang=js"
import style0 from "./DepartmentListItem.vue?vue&type=style&index=0&id=58c13b6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c13b6d",
  null
  
)

export default component.exports